module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bkloading",
      rawName: "v-bkloading",
      value: ({
        isLoading: _vm.appLoading
      }),
      expression: "{ isLoading: appLoading }"
    }],
    staticClass: "app_detail"
  }, [_c('section', {
    staticClass: "top-wrapper"
  }, [(Object.keys(_vm.appDetail).length) ? _c('div', {
    class: ['product-detail', {
      'fold': !_vm.showMore
    }]
  }, [_c('div', {
    staticClass: "product-detail-header"
  }, [_c('span', {
    staticClass: "go-back",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/s-mart/market'
        })
      }
    }
  }, [_vm._v("市场 /")]), _vm._v(" "), _c('span', {
    staticClass: "product-detail-text"
  }, [_vm._v("产品详情")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('div', {
    staticClass: "left-content column-layout"
  }, [_c('div', {
    staticClass: "product-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.appDetail.app_logo,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.appDetail.pay_type === 3) ? _c('img', {
    staticClass: "inquiry",
    attrs: {
      "src": require("../images/application_detail/inquiry-radius.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.appDetail.name))]), _vm._v(" "), _c('div', {
    staticClass: "scoring-like"
  }, [_c('el-rate', {
    staticClass: "star-rate",
    attrs: {
      "disabled": true,
      "void-icon-class": "el-icon-star-on",
      "disabled-void-color": "#c4c6cc",
      "colors": ['#fe9c00', '#fe9c00', '#fe9c00']
    },
    model: {
      value: (_vm.appDetail.star),
      callback: function($$v) {
        _vm.$set(_vm.appDetail, "star", $$v)
      },
      expression: "appDetail.star"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.appDetail.star) + "分")]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.isCollect ? '取消收藏' : '添加收藏',
      "placement": "top"
    }
  }, [_c('span', {
    class: ['icon-heart', {
      'icon-heart-shape': _vm.isCollect
    }],
    on: {
      "click": _vm.handleCollect
    }
  })]), _vm._v("\n                        " + _vm._s(_vm.appDetail.fan_num) + "\n                    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "center-content column-layout"
  }, [_c('ul', {
    staticClass: "product-info"
  }, [_vm._l((_vm.appOpitons), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "info-item"
    }, [_c('label', [_vm._v(_vm._s(item.label) + " : ")]), _vm._v(" "), _c('div', {
      staticClass: "info-content"
    }, [_vm._v("\n                                " + _vm._s((item.isArrary ? _vm.appDetail[item.key].join('，') : _vm.appDetail[item.key]) || '--') + "\n                            ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "info-item"
  }, [_c('label', [_vm._v("发布者 : ")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.appDetail.user.nick_name))]), _vm._v(" "), _vm._l((_vm.badgeList), function(badge, index) {
    return [(_vm.appDetail.user.user_badges[index]) ? _c('el-tooltip', {
      key: index,
      attrs: {
        "content": badge.text,
        "effect": "dark",
        "placement": "top"
      }
    }, [_c('img', {
      staticClass: "icon-medal",
      attrs: {
        "src": badge.url,
        "alt": ""
      }
    })]) : _vm._e()]
  })], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "product-desc"
  }, [_c('div', {
    staticClass: "introduction"
  }, [_vm._v("作品简介 : ")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.appDetail.desc))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "right-content column-layout"
  }, [(_vm.appDetail.pay_type !== 3) ? [_c('span', {
    staticClass: "download-btn",
    on: {
      "click": _vm.download
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/application_detail/icon-download-5.png"),
      "alt": ""
    }
  }), _vm._v("\n                            立即下载\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "download-num"
  }, [_c('span', [_vm._v("大小 : ")]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.appDetail.size || '--'))]), _vm._v(" "), _c('span', [_vm._v("下载次数 : ")]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.appDetail.download_num))])])] : _c('span', {
    staticClass: "download-btn",
    on: {
      "click": function($event) {
        _vm.popupShow = true;
        _vm.goTrack('', false, 'detail-advisory')
      }
    }
  }, [_vm._v("\n                        立即询价\n                    ")]), _vm._v(" "), _vm._m(0)], 2)]), _vm._v(" "), (_vm.displayMoreIcon) ? _c('div', {
    staticClass: "more-content"
  }, [_c('div', {
    staticClass: "more-content-btn",
    on: {
      "click": _vm.changeShow
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.showMore ? '收起' : '更多') + "\n                    "), (!_vm.showMore) ? _c('i', {
    staticClass: "el-icon-arrow-down"
  }) : _c('i', {
    staticClass: "el-icon-arrow-up"
  })])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('section', {
    class: ['router-wrapper', {
      'is-fixed': _vm.isFixed
    }]
  }, [_c('div', {
    staticClass: "router-list"
  }, _vm._l((_vm.routerList), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "router-item",
      attrs: {
        "to": item.to
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.handleRouter(item.track)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "route-content"
  }, [_c('router-view', {
    attrs: {
      "user": _vm.user,
      "badge-list": _vm.badgeList,
      "app-detail": _vm.appDetail
    }
  })], 1)]), _vm._v(" "), _c('popup', {
    staticClass: "whale-coin",
    attrs: {
      "show": _vm.popupShow
    },
    on: {
      "close": _vm.closePopup
    }
  }, [_c('ul', {
    staticClass: "whale-content",
    attrs: {
      "slot": "popup-body"
    },
    slot: "popup-body"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("作品名称：")]), _vm._v(" "), _c('p', {
    staticClass: "work-name"
  }, [_vm._v("列出占用系统资源最高的十个进程")])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("鲸币：")]), _vm._v(" "), _c('p', {
    staticClass: "coin-num"
  }, [_vm._v("325")])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("服务协议：")]), _vm._v(" "), _c('p', {
    staticClass: "agreement"
  }, [_vm._v("一年内免费版本升级")])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("鲸币余额：")]), _vm._v(" "), _c('p', {
    staticClass: "balance"
  }, [_vm._v("1200")])])]), _vm._v(" "), _c('div', {
    staticClass: "whale-button",
    attrs: {
      "slot": "popup-footer"
    },
    slot: "popup-footer"
  }, [_c('a', {
    staticClass: "confirm-button",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("确认购买")])])]), _vm._v(" "), _c('popup', {
    staticClass: "public",
    attrs: {
      "show": _vm.popupShow
    },
    on: {
      "close": _vm.closePopup
    }
  }, [_c('div', {
    attrs: {
      "slot": "popup-body"
    },
    slot: "popup-body"
  }, [(_vm.appDetail.pay_type === 3) ? _c('div', {
    staticClass: "public-content"
  }, [_c('div', {
    staticClass: "round"
  }, [_c('img', {
    attrs: {
      "src": require("../images/application_detail/pops-download.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("正在为您自动下载“" + _vm._s(_vm.appDetail.name) + "”")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("如果您的浏览器不支持自动下载，请手动下载该作品")]), _vm._v(" "), (_vm.appDetail.pay_type === 3 && _vm.downloadUrl === '') ? _c('p', {
    staticClass: "confirm-button disabled"
  }, [_vm._v("下载地址")]) : _c('a', {
    staticClass: "confirm-button",
    attrs: {
      "href": _vm.downloadUrl
    }
  }, [_vm._v("下载地址")])]) : _vm._e(), _vm._v(" "), (_vm.appDetail.pay_type === 3) ? _c('div', {
    staticClass: "public-content consult"
  }, [_c('div', {
    staticClass: "round"
  }, [_c('img', {
    attrs: {
      "src": require("../images/application_detail/pops-phone.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.appDetail.company_phone))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("请联系应用提供商"), _c('strong', [_vm._v("“" + _vm._s(_vm.appDetail.user.nick_name) + "”")]), _vm._v("进行咨询")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("该作品未开放下载购买")]), _vm._v(" "), _c('router-link', {
    staticClass: "detail-button",
    attrs: {
      "to": {
        path: '/s-mart/personal_center/user/' + _vm.appDetail.user.id
      }
    }
  }, [_vm._v("查看服务商详情")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "public-content warning hide"
  }, [_c('div', {
    staticClass: "round"
  }, [_c('i', [_c('img', {
    attrs: {
      "src": require("../images/application_detail/pops-waring.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("文件编译失败，请联系客服解决")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("错误码：134")]), _vm._v(" "), _c('a', {
    staticClass: "confirm-button white",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("联系客服")])]), _vm._v(" "), _c('div', {
    staticClass: "public-content hide"
  }, [_c('div', {
    staticClass: "round tempo"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("12")]), _vm._v("%")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("正在为您编译文件，大约需要1分钟，请稍后..")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v("初次下载该作品需要经过较长的编译时间")]), _vm._v(" "), _c('p', [_vm._v("您也可以关闭该弹层，先去浏览下其他作品")])])]), _vm._v(" "), _c('div', {
    staticClass: "public-content hide"
  }, [_c('div', {
    staticClass: "round tempo"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("78")]), _vm._v("%")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("正在为您生成个人编译器，大约需要2分钟，请稍后..")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v("后续使用过程中不会再重复生成，可以在用户中心下载自己的编译器")])])]), _vm._v(" "), _c('div', {
    staticClass: "loading-box hide"
  }, [_c('div', {
    staticClass: "loading"
  }, _vm._l((12), function(item) {
    return _c('div', {
      key: item,
      class: ("strip strip" + item)
    })
  }), 0)])])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": require("../images/personal_center/avatar_default.png"),
      "alt": "",
      "id": "avatar_default"
    }
  }), _vm._v(" "), (_vm.isShowBackTop) ? _c('div', {
    staticClass: "back-top",
    on: {
      "click": _vm.goBackTop
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share share-area"
  }, [_c('span', [_vm._v("分享给朋友：")]), _vm._v(" "), _c('div', {
    staticClass: "social-share"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-b02353c8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application_detail.vue
// module id = 5YMp
// module chunks = 15